import React from 'react';
import { Text, Box } from 'rimble-ui';
const LeftDemoAddress = ({ chainID }) => {
	const copyToClipBoard = async (copyMe) => {
		try {
			await navigator.clipboard.writeText(copyMe);
		} catch (err) {
			console.log(err);
		}
	};
	return (
		(chainID === 3 && (
			<div
				style={{
					left: '0px',
					bottom: '10px',
					position: 'absolute',
					margin: '10px',
					display: 'block',
					marginBottom: '50px'
				}}
			>
				<Text fontSize="3"> Address for testing </Text>
				<Text fontSize="1">
					{' '}
					0xf7367F3abDB31428Ed56032AbC14B245fCC95BA0{' '}
					<button
						onClick={() => copyToClipBoard('0xf7367F3abDB31428Ed56032AbC14B245fCC95BA0')}
						style={{
							marginLeft: '3px',
							borderRadius: '6px',
							backgroundColor: 'transparent',
							color: 'white',
							cursor: 'pointer'
						}}
					>
						Copy
					</button>
				</Text>
				<Text fontSize="1">
					{' '}
					0x5406a5323Ea6D3dc07e97361dEEcce3E9DaB7551{' '}
					<button
						onClick={() => copyToClipBoard('0x5406a5323Ea6D3dc07e97361dEEcce3E9DaB7551')}
						style={{
							marginLeft: '5px',
							borderRadius: '6px',
							backgroundColor: 'transparent',
							color: 'white',
							cursor: 'pointer'
						}}
					>
						Copy
					</button>{' '}
				</Text>
				<Text fontSize="1">
					{' '}
					0xEE9a9Fb49Da742E59cF4Ea50CED02465fda0A8Fb{' '}
					<button
						onClick={() => copyToClipBoard('0xEE9a9Fb49Da742E59cF4Ea50CED02465fda0A8Fb')}
						style={{
							marginLeft: '5px',
							borderRadius: '6px',
							backgroundColor: 'transparent',
							color: 'white',
							cursor: 'pointer'
						}}
					>
						Copy
					</button>
				</Text>
			</div>
		)) ||
		(chainID === 1 && (
			<div
				style={{
					left: '0px',
					bottom: '10px',
					position: 'absolute',
					margin: '10px',
					display: 'block',
					marginBottom: '50px'
				}}
			>
				<Box width={256}>
					{' '}
					<Text>
						When sending to more than 1 receiver, set to relatively High Gas Price to prevent fail
						transaction due to expired signatures.( Mined within 1 hour++ )
					</Text>{' '}
					<br />
					<Text> Switch to Ropsten Testnet to test.</Text> <br />
					<Text fontSize="3"> To Donate : </Text>
					<Text fontSize="3">
						{' '}
						🧙🏻‍♂️ Spellcaster.eth{' '}
						<button
							onClick={() => copyToClipBoard('Spellcaster.eth')}
							style={{
								borderRadius: '6px',
								backgroundColor: 'transparent',
								color: 'white',
								cursor: 'pointer'
							}}
						>
							Copy
						</button>
					</Text>
				</Box>
			</div>
		))
	);
};

export default LeftDemoAddress;
